module.exports = __webpack_public_path__ + "static/media/2_image2.d101dff1.jpg";